module.exports = __webpack_public_path__ + "static/img/characterC.a649c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/characterC.png
// module id = 7g71
// module chunks = 1